import React, { useState } from "react";
import { Lock, Key, TrendingUp } from "lucide-react";

/**
 * ダッシュボード全体のアクセスを制限するゲートコンポーネント
 */
export default function DashboardGate(props) {
  const [licenseKey, setLicenseKey] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [authError, setAuthError] = useState("");

  const handleVerifyLicense = async function () {
    if (!licenseKey) return;
    setIsVerifying(true);
    setAuthError("");

    try {
      const response = await fetch("/api/verify-license", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: licenseKey }),
      });
      const data = await response.json();

      if (data.success) {
        // 認証成功
        if (props.onUnlocked) {
          props.onUnlocked();
        }
      } else {
        setAuthError(data.message || "無効なライセンスキーです。");
      }
    } catch (err) {
      setAuthError("認証サーバーと通信できません。");
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: props.isDarkMode ? "#0f0e13" : "#f4f7fa",
        color: props.isDarkMode ? "#ffffff" : "#1e293b",
        padding: "20px",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "450px",
          padding: "40px",
          background: props.isDarkMode ? "rgba(255,255,255,0.03)" : "#ffffff",
          backdropFilter: "blur(10px)",
          borderRadius: "24px",
          boxShadow: props.isDarkMode 
            ? "0 20px 50px rgba(0,0,0,0.5)" 
            : "0 20px 50px rgba(0,0,0,0.05)",
          border: props.isDarkMode 
            ? "1px solid rgba(255,255,255,0.05)" 
            : "1px solid rgba(0,0,0,0.05)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div
            style={{
              width: "80px",
              height: "80px",
              background: "linear-gradient(135deg, #2c2d96 0%, #4f46e5 100%)",
              borderRadius: "22px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              boxShadow: "0 10px 20px rgba(44, 45, 150, 0.3)",
              transform: "rotate(-5deg)",
            }}
          >
            <Lock size={36} color="#fff" />
          </div>
          <h1 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "12px", letterSpacing: "-0.5px" }}>
            astronica
          </h1>
          <p style={{ color: props.isDarkMode ? "#94a3b8" : "#64748b", fontSize: "15px", lineHeight: "1.5" }}>
            試用期間が終了しました。<br />
            引き続きご利用いただくには、ライセンスキーを入力してください。
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div style={{ position: "relative" }}>
            <Key
              size={18}
              style={{
                position: "absolute",
                left: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#94a3b8",
                zIndex: 1,
              }}
            />
            <input
              type="password"
              placeholder="ライセンスキーを入力"
              value={licenseKey}
              onChange={function (e) {
                setLicenseKey(e.target.value);
              }}
              style={{
                width: "100%",
                padding: "16px 16px 16px 48px",
                borderRadius: "14px",
                border: "2px solid " + (authError ? "#ef4444" : (props.isDarkMode ? "rgba(255,255,255,0.1)" : "#e2e8f0")),
                outline: "none",
                fontSize: "15px",
                background: props.isDarkMode ? "#1a191e" : "#fff",
                color: props.isDarkMode ? "#fff" : "#1e293b",
                transition: "all 0.2s ease",
                boxSizing: "border-box",
              }}
            />
          </div>
          
          {authError && (
            <div style={{ 
              color: "#ef4444", 
              fontSize: "14px", 
              fontWeight: "600",
              textAlign: "center",
              marginTop: "-12px" 
            }}>
              {authError}
            </div>
          )}

          <button
            onClick={handleVerifyLicense}
            disabled={isVerifying}
            style={{
              padding: "16px",
              background: "#2c2d96",
              color: "#fff",
              borderRadius: "14px",
              fontWeight: "700",
              border: "none",
              cursor: isVerifying ? "wait" : "pointer",
              opacity: isVerifying ? 0.7 : 1,
              fontSize: "16px",
              boxShadow: "0 4px 12px rgba(44, 45, 150, 0.2)",
              transition: "transform 0.2s active",
            }}
          >
            {isVerifying ? "認証中..." : "認証してアンロック"}
          </button>
        </div>

        <div style={{ marginTop: "32px", textAlign: "center", borderTop: props.isDarkMode ? "1px solid rgba(255,255,255,0.05)" : "1px solid #f1f5f9", paddingTop: "24px" }}>
          <p style={{ fontSize: "13px", color: props.isDarkMode ? "#64748b" : "#94a3b8" }}>
            ライセンスキーをお持ちでない場合は、<br />
            サポートまでお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
}